(function($) {
  'use strict';

  $(window).scroll( () => {
    const scrolled = $(window).scrollTop();
    let navHeight = $("[id=nav--main]").outerHeight();

    if( scrolled > 93 ) {
      $("[id=nav--main]").parents('header').addClass('scrolled');
      $("[id=block-siteannouncement]").css({
        'margin-top' : navHeight,
      });
    } else {
      $("[id=nav--main]").parents('header').removeClass('scrolled');
      $("[id=block-siteannouncement]").css({
        'margin-top' : '0',
      });
    }
  });

})(jQuery);
